/** @format */

import { action, makeObservable, observable } from "mobx";

import StoresType from "./types";

export enum Language {
  korean = "ko-KR",
  english = "en"
}

const getLanguage = (value: string) => {
  const key = Object.entries(Language).find(([key, val]) => val === value)?.[0];
  if (key) {
    return Language[key];
  } else {
    return Language.english;
  }
};

export default class Settings {
  stores: StoresType;

  language: Language = (() => {
    const storedLanguage = localStorage.getItem("language");

    if (storedLanguage) {
      return getLanguage(storedLanguage);
    } else {
      const browserLanguage = getLanguage(navigator.language);
      localStorage.setItem("language", browserLanguage);
      return browserLanguage;
    }
  })();

  setLanguage(value: Language) {
    localStorage.setItem("language", value);
    this.language = value;
  }

  currentPath = "";
  setCurrentPath(currentPath: string) {
    this.currentPath = currentPath;
  }

  isSidebarOpen: boolean = false;
  setSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  isDirectingQnA: boolean = false;
  setDirectingQnA() {
    this.isDirectingQnA = !this.isDirectingQnA;
  }

  constructor(stores: StoresType) {
    makeObservable(this, {
      language: observable,
      setLanguage: action.bound,

      currentPath: observable,
      setCurrentPath: action.bound,

      isSidebarOpen: observable,
      setSidebar: action.bound,

      isDirectingQnA: observable,
      setDirectingQnA: action.bound
    });
    this.stores = stores;
  }
}
